import React, { useMemo, useState } from "react";
import { Check, Share2 } from "lucide-react";

const shareUrlFor = (product) => {
  if (typeof window === "undefined") return "";
  const slug = product?.seo_slug || product?.slug;
  return slug ? `${window.location.origin}/product/${slug}` : window.location.href;
};

const ProductShareButton = ({ product, className = "", compact = false, labelClassName = "" }) => {
  const [status, setStatus] = useState("idle");
  const shareUrl = useMemo(() => shareUrlFor(product), [product]);
  const shareTitle = product?.name ? `${product.name} | Cynos` : "Cynos Streetwear";
  const shareText = product?.name
    ? `Check out ${product.name} on Cynos.`
    : "Check out this Cynos streetwear drop.";

  const handleShare = async () => {
    setStatus("idle");

    try {
      if (navigator.share) {
        await navigator.share({
          title: shareTitle,
          text: shareText,
          url: shareUrl,
        });
        setStatus("shared");
      } else if (navigator.clipboard?.writeText) {
        await navigator.clipboard.writeText(shareUrl);
        setStatus("copied");
      } else {
        window.open(`https://wa.me/?text=${encodeURIComponent(`${shareText} ${shareUrl}`)}`, "_blank", "noopener,noreferrer");
        setStatus("shared");
      }
    } catch (error) {
      if (error?.name !== "AbortError") {
        setStatus("error");
      }
    }

    window.setTimeout(() => setStatus("idle"), 2200);
  };

  const label = status === "copied"
    ? "Link Copied"
    : status === "shared"
      ? "Shared"
      : status === "error"
        ? "Tap To Copy Link"
        : "Share Product";

  return (
    <button
      type="button"
      onClick={handleShare}
      className={`inline-flex min-h-[52px] items-center justify-center gap-2 rounded-[8px] border border-white/15 bg-white/[0.03] px-4 font-mono text-[11px] uppercase tracking-[0.18em] text-zinc-100 transition hover:border-white hover:bg-white hover:text-black ${compact ? "" : "w-full"} ${className}`}
      aria-label={`Share ${product?.name || "this product"}`}
      data-testid="product-share-btn"
    >
      {status === "copied" || status === "shared" ? <Check size={16} /> : <Share2 size={16} />}
      <span className={labelClassName}>{label}</span>
    </button>
  );
};

export default ProductShareButton;
